<div class="w-full px-6 py-6">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">
        <i class="fas fa-shopping-bag text-blue-600 mr-2"></i>
        Productos de Compra
      </h1>
      <p class="mt-1 text-sm text-gray-500">Análisis de movimiento, ventas y financiamiento de productos en tienda</p>
    </div>
    <div class="flex items-center gap-3 mt-4 sm:mt-0">
      <button (click)="loadData(true)" title="Refrescar datos"
              class="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">
        <i class="fas fa-sync-alt" [class.fa-spin]="loadingStats || loading"></i>
      </button>
      <button (click)="openCreateModal()"
              class="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm">
        <i class="fas fa-plus"></i>
        Nuevo Producto
      </button>
    </div>
  </div>

  <!-- KPI Cards compactas (arriba del período) -->
  <div class="grid grid-cols-4 gap-3 mb-4" *ngIf="enhanced">
    <div class="bg-white rounded-lg border border-gray-200 px-3 py-2 flex items-center gap-3">
      <div class="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center shrink-0"><i class="fas fa-file-invoice-dollar text-amber-600 text-sm"></i></div>
      <div class="min-w-0">
        <p class="text-[10px] font-medium text-gray-500 uppercase truncate">Créditos</p>
        <p class="text-lg font-bold text-amber-600 leading-tight">{{formatNumber(enhanced.kpis.total_credits)}}</p>
      </div>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 px-3 py-2 flex items-center gap-3">
      <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center shrink-0"><i class="fas fa-boxes text-blue-600 text-sm"></i></div>
      <div class="min-w-0">
        <p class="text-[10px] font-medium text-gray-500 uppercase truncate">Productos vendidos</p>
        <p class="text-lg font-bold text-gray-900 leading-tight">{{formatNumber(enhanced.kpis.unique_products_sold)}}</p>
      </div>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 px-3 py-2 flex items-center gap-3">
      <div class="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center shrink-0"><i class="fas fa-shopping-cart text-purple-600 text-sm"></i></div>
      <div class="min-w-0">
        <p class="text-[10px] font-medium text-gray-500 uppercase truncate">Unidades vendidas</p>
        <p class="text-lg font-bold text-purple-600 leading-tight">{{formatNumber(enhanced.kpis.total_units_sold)}}</p>
      </div>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 px-3 py-2 flex items-center gap-3">
      <div class="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center shrink-0"><i class="fas fa-dollar-sign text-green-600 text-sm"></i></div>
      <div class="min-w-0">
        <p class="text-[10px] font-medium text-gray-500 uppercase truncate">Vendido (USD)</p>
        <p class="text-lg font-bold text-green-700 leading-tight">${{ (enhanced.kpis.total_revenue_usd || 0) | number:'1.2-2' }}</p>
        <p class="text-[10px] text-gray-400 leading-tight">{{ (enhanced.kpis.total_revenue_bs || 0) | number:'1.0-0' }} Bs</p>
      </div>
    </div>
  </div>

  <!-- Period Filter -->
  <div class="flex flex-wrap items-center gap-2 mb-3">
    <span class="text-sm font-medium text-gray-600 mr-1">Período:</span>
    <button *ngFor="let p of periods"
            (click)="onPeriodChange(p.value)"
            class="px-3.5 py-1.5 rounded-full text-sm font-medium transition-all"
            [ngClass]="{
              'bg-blue-600 text-white shadow-sm': selectedPeriod === p.value,
              'bg-white text-gray-600 border border-gray-300 hover:bg-gray-50': selectedPeriod !== p.value
            }">
      {{p.label}}
    </button>
  </div>

  <!-- Indicador de estado: la fecha de actualización SIEMPRE visible + spinner al refrescar -->
  <div class="flex items-center gap-1.5 text-xs text-gray-400 mb-3 h-4">
    <i *ngIf="loadingStats || loading" class="fas fa-circle-notch fa-spin text-blue-500"></i>
    <i *ngIf="!(loadingStats || loading)" class="far fa-clock"></i>
    <span *ngIf="lastUpdate">Actualizado: {{ lastUpdate | date:'dd/MM/yy HH:mm' }}</span>
    <span *ngIf="(loadingStats || loading) && !lastUpdate" class="text-blue-500">Actualizando…</span>
    <span *ngIf="(loadingStats || loading) && lastUpdate" class="text-blue-500 ml-1">· actualizando…</span>
    <!-- 📅 Piso del módulo. Sin este cartel, un total más bajo de lo esperado parece
         un error de cálculo en vez de un recorte de fecha deliberado. -->
    <span *ngIf="dataFrom" class="ml-2 pl-2 border-l border-gray-300">
      Productos de créditos desde el {{ dataFrom | date:'dd/MM/yyyy' }}
    </span>
  </div>

  <!-- Filtros avanzados (Fecha / Tienda / Sector / Plan / Producto) con autocomplete -->
  <div class="bg-white rounded-xl border border-gray-200 p-4 mb-6">
    <div class="flex flex-col lg:flex-row lg:items-end gap-3">
      <div class="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3">
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Desde</label>
          <input type="date" [(ngModel)]="dateFrom" (ngModelChange)="onManualDateChange()"
                 [min]="minDate" [title]="minDate ? 'El módulo arranca el ' + minDate : ''"
                 class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Hasta</label>
          <input type="date" [(ngModel)]="dateTo" (ngModelChange)="onManualDateChange()"
                 [min]="minDate"
                 class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>
        <!-- Tienda / Agencia (multi-selección) -->
        <div class="relative">
          <label class="block text-xs font-medium text-gray-600 mb-1">
            Tienda / Agencia
            <span *ngIf="selectedShops.length" class="text-blue-600">({{selectedShops.length}})</span>
            <button *ngIf="selectedShops.length" type="button" (click)="selectedShops = []"
                    class="text-gray-400 hover:text-red-600 ml-1">· limpiar</button>
          </label>
          <input type="text"
                 [ngModel]="shopInput"
                 (input)="onShopInputChange($any($event.target).value)"
                 (focus)="shopDropdownOpen = true"
                 (click)="onShopInputClick()"
                 (blur)="closeShopDropdown()"
                 [placeholder]="selectedShops.length ? 'Agregar otra tienda…' : 'Todas las tiendas'"
                 autocomplete="off"
                 class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white">
          <div *ngIf="shopDropdownOpen && shopsFilter.length > 0"
               class="absolute z-30 mt-1 min-w-[340px] w-max max-w-[460px] bg-white border border-gray-200 rounded-lg shadow-lg max-h-72 overflow-hidden flex flex-col">
            <!-- toggle interno: todas / con compras / sin compras -->
            <div class="flex gap-1 p-1.5 border-b border-gray-100 bg-gray-50 text-xs shrink-0">
              <button type="button" (mousedown)="$event.preventDefault(); shopFilterMode='all'"
                      [ngClass]="shopFilterMode==='all' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 border border-gray-200'"
                      class="px-2 py-1 rounded-full">Todas</button>
              <button type="button" (mousedown)="$event.preventDefault(); shopFilterMode='with'"
                      [ngClass]="shopFilterMode==='with' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 border border-gray-200'"
                      class="px-2 py-1 rounded-full">Con compras</button>
              <button type="button" (mousedown)="$event.preventDefault(); shopFilterMode='without'"
                      [ngClass]="shopFilterMode==='without' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 border border-gray-200'"
                      class="px-2 py-1 rounded-full">Sin compras</button>
            </div>
            <div class="overflow-y-auto">
              <button *ngFor="let s of filteredShops"
                      type="button"
                      (mousedown)="$event.preventDefault(); toggleShop(s)"
                      class="w-full text-left px-3 py-2 text-sm hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-b-0 flex items-center gap-2"
                      [class.bg-blue-50]="isShopSelected(s.code)">
                <i class="fas fa-check text-blue-600 text-xs w-3 shrink-0" [class.invisible]="!isShopSelected(s.code)"></i>
                <span class="font-mono text-xs text-gray-500 w-12 shrink-0">{{s.code}}</span>
                <span class="flex-1 text-gray-700">{{s.name || '(sin nombre)'}}</span>
                <span *ngIf="!s.has_purchases" class="text-[10px] text-gray-300 shrink-0">sin compras</span>
              </button>
              <div *ngIf="filteredShops.length === 0" class="px-3 py-3 text-xs text-gray-400">Sin tiendas en este modo</div>
            </div>
          </div>
          <div *ngIf="shopDropdownOpen && filteredShops.length === 0 && shopsFilter.length === 0"
               class="absolute z-30 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-xs text-gray-500">
            Cargando tiendas...
          </div>
        </div>

        <!-- Sector (multi-selección) -->
        <div class="relative">
          <label class="block text-xs font-medium text-gray-600 mb-1">
            Sector
            <span *ngIf="selectedSectors.length" class="text-blue-600">({{selectedSectors.length}})</span>
            <button *ngIf="selectedSectors.length" type="button" (click)="selectedSectors = []"
                    class="text-gray-400 hover:text-red-600 ml-1">· limpiar</button>
          </label>
          <input type="text"
                 [ngModel]="sectorInput"
                 (input)="onSectorInputChange($any($event.target).value)"
                 (focus)="sectorDropdownOpen = true"
                 (click)="onSectorInputClick()"
                 (blur)="closeSectorDropdown()"
                 [placeholder]="selectedSectors.length ? 'Agregar otro sector…' : 'Todos los sectores'"
                 autocomplete="off"
                 class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white">
          <div *ngIf="sectorDropdownOpen && filteredSectors.length > 0"
               class="absolute z-30 mt-1 min-w-[260px] w-max max-w-[400px] bg-white border border-gray-200 rounded-lg shadow-lg max-h-64 overflow-y-auto">
            <button *ngFor="let s of filteredSectors"
                    type="button"
                    (mousedown)="$event.preventDefault(); toggleSector(s)"
                    class="w-full text-left px-3 py-2 text-sm hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-b-0 flex items-center gap-2"
                    [class.bg-blue-50]="isSectorSelected(s.se)">
              <i class="fas fa-check text-blue-600 text-xs w-3 shrink-0" [class.invisible]="!isSectorSelected(s.se)"></i>
              <span class="text-gray-700">{{getSectorName(s.se)}}</span>
            </button>
          </div>
        </div>

        <!-- Plan de compra (multi-selección) -->
        <div class="relative">
          <label class="block text-xs font-medium text-gray-600 mb-1">
            Plan de compra
            <span *ngIf="selectedPlans.length" class="text-blue-600">({{selectedPlans.length}})</span>
            <button *ngIf="selectedPlans.length" type="button" (click)="selectedPlans = []"
                    class="text-gray-400 hover:text-red-600 ml-1">· limpiar</button>
          </label>
          <input type="text"
                 [ngModel]="planInput"
                 (input)="onPlanInputChange($any($event.target).value)"
                 (focus)="planDropdownOpen = true"
                 (click)="onPlanInputClick()"
                 (blur)="closePlanDropdown()"
                 [placeholder]="selectedPlans.length ? 'Agregar otro plan…' : 'Todos los planes'"
                 autocomplete="off"
                 class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white">
          <div *ngIf="planDropdownOpen && filteredPlans.length > 0"
               class="absolute z-30 mt-1 min-w-[300px] w-max max-w-[440px] bg-white border border-gray-200 rounded-lg shadow-lg max-h-64 overflow-y-auto">
            <button *ngFor="let p of filteredPlans"
                    type="button"
                    (mousedown)="$event.preventDefault(); togglePlan(p)"
                    class="w-full text-left px-3 py-2 text-sm hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-b-0 flex items-center gap-2"
                    [class.bg-blue-50]="isPlanSelected(p._id)">
              <i class="fas fa-check text-blue-600 text-xs w-3 shrink-0" [class.invisible]="!isPlanSelected(p._id)"></i>
              <span *ngIf="p.code" class="font-mono text-xs text-gray-500 shrink-0">{{p.code}}</span>
              <span class="text-gray-700">{{p.name}}</span>
            </button>
          </div>
        </div>

        <!-- Código de producto -->
        <div class="relative">
          <label class="block text-xs font-medium text-gray-600 mb-1">Código de producto</label>
          <input type="text"
                 [ngModel]="productCode"
                 (input)="onProductCodeInput($any($event.target).value)"
                 (focus)="productDropdownOpen = true"
                 (blur)="closeProductDropdown()"
                 placeholder="Ej: LGG19UG01B40UN"
                 autocomplete="off"
                 class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
          <div *ngIf="productDropdownOpen && productSearchResults.length > 0"
               class="absolute z-30 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-64 overflow-y-auto">
            <button *ngFor="let p of productSearchResults"
                    type="button"
                    (mousedown)="selectProduct(p)"
                    class="w-full text-left px-3 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors border-b border-gray-100 last:border-b-0">
              <div class="font-mono text-xs text-gray-500">{{p.code}}</div>
              <div class="text-gray-700 truncate">{{p.name}}</div>
            </button>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="applyAdvancedFilters()"
                [disabled]="applyingFilters"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed flex items-center gap-1.5">
          <i [class]="applyingFilters ? 'fas fa-spinner fa-spin' : 'fas fa-filter'"></i>
          {{ applyingFilters ? 'Filtrando…' : 'Aplicar' }}
        </button>
        <button (click)="clearAdvancedFilters()"
                [disabled]="applyingFilters"
                class="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors whitespace-nowrap disabled:opacity-60">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="flex border-b border-gray-200 mb-6">
    <button (click)="setActiveTab('overview')"
            class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
            [ngClass]="activeTab === 'overview' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
      <i class="fas fa-chart-bar mr-1.5"></i> Resumen
    </button>
    <button (click)="setActiveTab('products')"
            class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
            [ngClass]="activeTab === 'products' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
      <i class="fas fa-list mr-1.5"></i> Productos
    </button>
    <button (click)="setActiveTab('sectors')"
            class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
            [ngClass]="activeTab === 'sectors' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
      <i class="fas fa-industry mr-1.5"></i> Sectores
    </button>
    <button (click)="setActiveTab('shops')"
            class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
            [ngClass]="activeTab === 'shops' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
      <i class="fas fa-store mr-1.5"></i> Tiendas
    </button>
  </div>

  <!-- ==================== TAB: RESUMEN ==================== -->
  <div *ngIf="activeTab === 'overview'">

    <!-- Charts Row 1: Time Series + Top Products -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
        <h3 class="text-sm font-semibold text-gray-700 mb-4">
          <i class="fas fa-chart-line text-blue-600 mr-1.5"></i> Ventas en el Tiempo
        </h3>
        <div class="h-[280px]">
          <canvas id="timeSeriesChart"></canvas>
        </div>
        <div *ngIf="!enhanced?.time_series?.length" class="flex items-center justify-center h-[280px] text-gray-400 text-sm">
          <div class="text-center">
            <i class="fas fa-chart-line text-3xl mb-2"></i>
            <p>Sin datos en este período</p>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
        <h3 class="text-sm font-semibold text-gray-700 mb-4">
          <i class="fas fa-trophy text-yellow-500 mr-1.5"></i> Top 10 - Más Vendidos
        </h3>
        <div class="h-[280px]">
          <canvas id="topProductsChart"></canvas>
        </div>
        <div *ngIf="!enhanced?.top_purchased?.length" class="flex items-center justify-center h-[280px] text-gray-400 text-sm">
          <div class="text-center">
            <i class="fas fa-trophy text-3xl mb-2"></i>
            <p>Sin compras en este período</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Chart: Sector -->
    <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm mb-6">
      <h3 class="text-sm font-semibold text-gray-700 mb-4">
        <i class="fas fa-industry text-indigo-600 mr-1.5"></i> Ventas por Sector
      </h3>
      <div class="h-[260px]">
        <canvas id="sectorChart"></canvas>
      </div>
      <div *ngIf="!enhanced?.by_sector?.length" class="flex items-center justify-center h-[260px] text-gray-400 text-sm">
        <div class="text-center">
          <i class="fas fa-industry text-3xl mb-2"></i>
          <p>Sin datos de sector en este período</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ==================== TAB: PRODUCTOS ==================== -->
  <div *ngIf="activeTab === 'products'">
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
      <!-- Search bar + Filters + Export -->
      <div class="p-4 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div class="flex items-center gap-3 flex-1">
          <div class="relative max-w-md flex-1">
            <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
            <input type="text"
                   placeholder="Buscar por nombre, código, marca, material, EAN..."
                   (input)="onSearch($any($event.target).value)"
                   class="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div class="text-sm text-gray-500" *ngIf="pagination.total > 0">
            <i class="fas fa-database mr-1"></i> {{formatNumber(pagination.total)}} productos
          </div>
          <button (click)="exportToXLS()"
                  [disabled]="exporting"
                  class="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap">
            <i [class]="exporting ? 'fas fa-spinner fa-spin' : 'fas fa-file-excel'"></i>
            {{exporting ? 'Exportando...' : 'Descargar XLS'}}
          </button>
        </div>
      </div>

      <!-- Table -->
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider cursor-pointer hover:bg-gray-100" (click)="onSort('code')">
                Código <i [class]="getSortIcon('code')" class="ml-1"></i>
              </th>
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider cursor-pointer hover:bg-gray-100" (click)="onSort('name')">
                Nombre <i [class]="getSortIcon('name')" class="ml-1"></i>
              </th>
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Marca</th>
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Material</th>
              <th class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">Sector</th>
              <th class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider cursor-pointer hover:bg-gray-100" (click)="onSort('stats.total_purchases')">
                Compras <i [class]="getSortIcon('stats.total_purchases')" class="ml-1"></i>
              </th>
              <th class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider cursor-pointer hover:bg-gray-100" (click)="onSort('stats.total_quantity_sold')">
                Unidades <i [class]="getSortIcon('stats.total_quantity_sold')" class="ml-1"></i>
              </th>
              <th class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider cursor-pointer hover:bg-gray-100" (click)="onSort('purchases')">
                Comprado (período) <i [class]="getSortIcon('purchases')" class="ml-1"></i>
              </th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider cursor-pointer hover:bg-gray-100" (click)="onSort('revenue_usd')">
                Vendido (USD) <i [class]="getSortIcon('revenue_usd')" class="ml-1"></i>
              </th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Precio prom. (USD)</th>
              <th class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr *ngFor="let product of products" (click)="viewProduct(product)"
                class="hover:bg-blue-50 cursor-pointer transition-colors group">
              <td class="px-4 py-3 text-sm font-mono text-blue-700 font-medium">{{product.code}}</td>
              <td class="px-4 py-3">
                <p class="text-sm font-medium text-gray-900">{{product.name}}</p>
                <p *ngIf="product.ean_upc" class="text-xs text-gray-400 font-mono">EAN: {{product.ean_upc}}</p>
              </td>
              <td class="px-4 py-3 text-sm text-gray-600">{{product.brand || '-'}}</td>
              <td class="px-4 py-3">
                <p class="text-sm text-gray-600 font-mono">{{product.material || '-'}}</p>
                <p *ngIf="product.numero_material" class="text-xs text-gray-400 truncate max-w-[200px]" [title]="product.numero_material">{{product.numero_material}}</p>
              </td>
              <td class="px-4 py-3 text-center">
                <span *ngIf="product.se" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">{{getSectorName(product.se)}}</span>
                <span *ngIf="!product.se" class="text-sm text-gray-400">-</span>
              </td>
              <td class="px-4 py-3 text-sm text-center">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                      [ngClass]="product.stats?.total_purchases > 0 ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'">
                  {{product.stats?.total_purchases || 0}}
                </span>
              </td>
              <td class="px-4 py-3 text-sm text-center">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                      [ngClass]="product.stats?.total_quantity_sold > 0 ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-500'">
                  {{product.stats?.total_quantity_sold || 0}}
                </span>
              </td>
              <!-- 🆕 Métricas DEL PERÍODO seleccionado (cambian al mover fechas) -->
              <td class="px-4 py-3 text-sm text-center">
                <span class="font-medium text-gray-900">{{product.period_purchases || 0}}</span>
                <span class="block text-xs text-gray-400">{{product.period_units || 0}} u</span>
              </td>
              <td class="px-4 py-3 text-sm text-right">
                <span class="font-semibold text-green-700">${{ (product.revenue_usd || 0) | number:'1.2-2' }}</span>
                <span class="block text-xs text-gray-400">{{ (product.revenue_bs || 0) | number:'1.0-0' }} Bs</span>
              </td>
              <td class="px-4 py-3 text-sm text-right font-mono text-gray-700">${{ (product.avg_price_usd || 0) | number:'1.2-2' }}</td>
              <td class="px-4 py-3 text-center" (click)="$event.stopPropagation()">
                <div class="flex items-center justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button (click)="startEdit(product, $event)" class="p-1.5 rounded-md text-gray-400 hover:text-blue-600 hover:bg-blue-50" title="Editar">
                    <i class="fas fa-pen text-xs"></i>
                  </button>
                  <button (click)="deleteProduct(product, $event)" class="p-1.5 rounded-md text-gray-400 hover:text-red-600 hover:bg-red-50" title="Desactivar">
                    <i class="fas fa-trash text-xs"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && products.length === 0" class="text-center py-16">
        <div class="mx-auto w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mb-4">
          <i class="fas fa-box-open text-3xl text-blue-400"></i>
        </div>
        <h3 class="text-lg font-medium text-gray-900 mb-2">No hay productos en el catálogo</h3>
        <p class="text-sm text-gray-500 mb-6 max-w-sm mx-auto">
          Los productos se registran automáticamente al consultar cupo, o puedes crearlos manualmente.
        </p>
        <button (click)="openCreateModal()"
                class="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors">
          <i class="fas fa-plus"></i> Crear primer producto
        </button>
      </div>

      <!-- Loading -->
      <div *ngIf="loading" class="flex items-center justify-center py-16">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
      </div>

      <!-- Pagination -->
      <div *ngIf="!loading && products.length > 0" class="flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50">
        <p class="text-sm text-gray-500">
          {{((pagination.page - 1) * pagination.limit) + 1}} - {{pagination.page * pagination.limit > pagination.total ? pagination.total : pagination.page * pagination.limit}} de {{pagination.total}}
        </p>
        <div class="flex items-center gap-2">
          <button (click)="goToPage(pagination.page - 1)" [disabled]="pagination.page <= 1"
                  class="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium hover:bg-white disabled:opacity-50 disabled:cursor-not-allowed">
            <i class="fas fa-chevron-left"></i>
          </button>
          <span class="text-sm text-gray-700 font-medium">{{pagination.page}} / {{pagination.pages}}</span>
          <button (click)="goToPage(pagination.page + 1)" [disabled]="pagination.page >= pagination.pages"
                  class="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium hover:bg-white disabled:opacity-50 disabled:cursor-not-allowed">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ==================== TAB: POR SECTOR ==================== -->
  <div *ngIf="activeTab === 'sectors'">

    <!-- Tabla principal de sectores -->
    <div class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mb-6">
      <div class="p-4 border-b border-gray-200">
        <h3 class="text-sm font-semibold text-gray-700">
          <i class="fas fa-industry text-indigo-600 mr-1.5"></i> Desglose de Ventas por Sector
        </h3>
        <p class="text-xs text-gray-500 mt-1">Rendimiento por sector en el período seleccionado</p>
      </div>

      <div class="overflow-x-auto" *ngIf="enhanced?.by_sector?.length > 0">
        <table class="w-full">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Sector</th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Productos</th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Unidades</th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Vendido (USD)</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr *ngFor="let sector of enhanced.by_sector; let i = index" class="hover:bg-gray-50">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <div class="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold"
                       [ngClass]="{ 'bg-indigo-100 text-indigo-700': i === 0, 'bg-purple-100 text-purple-700': i === 1, 'bg-blue-100 text-blue-700': i === 2, 'bg-gray-100 text-gray-600': i > 2 }">
                    {{i + 1}}
                  </div>
                  <span class="text-sm font-semibold text-gray-900">{{getSectorName(sector.se)}}</span>
                </div>
              </td>
              <td class="px-4 py-3 text-sm text-right">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">{{sector.product_count}}</span>
              </td>
              <td class="px-4 py-3 text-sm text-right font-mono text-gray-700">{{formatNumber(sector.total_units)}}</td>
              <td class="px-4 py-3 text-sm text-right">
                <span class="font-semibold text-green-700">${{ (sector.revenue_usd || 0) | number:'1.2-2' }}</span>
                <span class="block text-[10px] text-gray-400">{{ (sector.revenue_bs || 0) | number:'1.0-0' }} Bs</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="!enhanced?.by_sector?.length" class="p-12 text-center text-gray-400 text-sm">
        <i class="fas fa-industry text-3xl mb-3"></i>
        <p>Sin datos de sector en este período</p>
      </div>
    </div>


  </div>

  <!-- ==================== TAB: POR TIENDA ==================== -->
  <div *ngIf="activeTab === 'shops'">
    <div class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div class="p-4 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-gray-700">
            <i class="fas fa-store text-blue-600 mr-1.5"></i> Desglose de Ventas por Tienda
          </h3>
          <p class="text-xs text-gray-500 mt-1">Rendimiento de cada punto de venta en el período seleccionado</p>
        </div>
        <div class="flex items-center gap-2">
          <!-- toggle con/sin compras -->
          <div class="flex gap-1 text-xs">
            <button type="button" (click)="setShopTabMode('all')"
                    [ngClass]="shopTabMode==='all' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 border border-gray-300'"
                    class="px-3 py-1.5 rounded-full font-medium">Todas</button>
            <button type="button" (click)="setShopTabMode('with')"
                    [ngClass]="shopTabMode==='with' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 border border-gray-300'"
                    class="px-3 py-1.5 rounded-full font-medium">Con compras</button>
            <button type="button" (click)="setShopTabMode('without')"
                    [ngClass]="shopTabMode==='without' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 border border-gray-300'"
                    class="px-3 py-1.5 rounded-full font-medium">Sin compras</button>
          </div>
          <button (click)="exportShopsToXLS()"
                  class="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors shadow-sm whitespace-nowrap">
            <i class="fas fa-file-excel"></i> Descargar XLS
          </button>
        </div>
      </div>

      <div class="overflow-x-auto" *ngIf="shopRowsView.length > 0">
        <!-- Contador: mostrando X-Y de Z tiendas -->
        <div class="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100 text-xs text-gray-600">
          <span>
            Mostrando
            <strong class="text-gray-900">{{ shopsPageStart + 1 }}-{{ shopsPageEnd }}</strong>
            de
            <strong class="text-gray-900">{{ shopRowsView.length }}</strong>
            tiendas
          </span>
          <span class="text-gray-400">ordenadas por monto vendido (desc)</span>
        </div>
        <table class="w-full">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Tienda</th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Compras</th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Unidades</th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Vendido (USD)</th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Productos</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr *ngFor="let shop of paginatedShops; let i = index" class="hover:bg-gray-50">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <div class="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold"
                       [ngClass]="{ 'bg-blue-100 text-blue-700': (shopsPageStart + i) === 0, 'bg-purple-100 text-purple-700': (shopsPageStart + i) === 1, 'bg-green-100 text-green-700': (shopsPageStart + i) === 2, 'bg-gray-100 text-gray-600': (shopsPageStart + i) > 2 }">
                    {{ shopsPageStart + i + 1 }}
                  </div>
                  <div class="flex flex-col">
                    <span class="text-sm font-semibold text-gray-900">
                      Tienda {{shop.shop}}<span *ngIf="shop.shop_name || getShopName(shop.shop)" class="text-gray-700 font-normal"> - {{shop.shop_name || getShopName(shop.shop)}}</span>
                    </span>
                  </div>
                </div>
              </td>
              <td class="px-4 py-3 text-sm text-right font-mono text-gray-700">{{formatNumber(shop.purchases)}}</td>
              <td class="px-4 py-3 text-sm text-right font-mono text-gray-700">{{formatNumber(shop.total_units)}}</td>
              <td class="px-4 py-3 text-sm text-right">
                <span class="font-semibold text-green-700">${{ (shop.revenue_usd || 0) | number:'1.2-2' }}</span>
                <span class="block text-[10px] text-gray-400">{{ (shop.revenue_bs || 0) | number:'1.0-0' }} Bs</span>
              </td>
              <td class="px-4 py-3 text-sm text-right">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  {{shop.unique_products}}
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Paginación 10 en 10 -->
        <div *ngIf="enhanced.by_shop.length > shopsPageSize"
             class="flex items-center justify-between gap-2 py-3 px-4 border-t border-gray-100 bg-gray-50 flex-wrap">
          <div class="text-xs text-gray-600">
            Página <strong class="text-gray-900">{{ shopsPage }}</strong> de <strong class="text-gray-900">{{ shopsTotalPages }}</strong>
          </div>
          <div class="flex items-center gap-1">
            <button (click)="goToShopsPage(shopsPage - 1)"
                    [disabled]="shopsPage <= 1"
                    class="w-8 h-8 inline-flex items-center justify-center text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
              <i class="fas fa-chevron-left"></i>
            </button>
            <ng-container *ngFor="let p of shopsPageNumbers">
              <span *ngIf="p === '…'" class="px-2 text-xs text-gray-400">…</span>
              <button *ngIf="p !== '…'"
                      (click)="goToShopsPage($any(p))"
                      class="w-8 h-8 inline-flex items-center justify-center text-xs font-medium rounded border transition-colors"
                      [ngClass]="p === shopsPage
                        ? 'bg-blue-600 text-white border-blue-600'
                        : 'text-gray-700 bg-white border-gray-200 hover:bg-gray-50'">
                {{ p }}
              </button>
            </ng-container>
            <button (click)="goToShopsPage(shopsPage + 1)"
                    [disabled]="shopsPage >= shopsTotalPages"
                    class="w-8 h-8 inline-flex items-center justify-center text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!enhanced?.by_shop?.length" class="p-12 text-center text-gray-400 text-sm">
        <i class="fas fa-store text-3xl mb-3"></i>
        <p>Sin datos de tienda en este período</p>
      </div>
    </div>

  </div>

</div>

<!-- ===================== MODAL: CREAR PRODUCTO ===================== -->
<div *ngIf="showCreateModal" class="fixed inset-0 z-50 flex items-center justify-center p-4">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" (click)="closeCreateModal()"></div>

  <!-- Modal -->
  <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
            <i class="fas fa-plus text-blue-600"></i>
          </div>
          <div>
            <h2 class="text-lg font-bold text-gray-900">Nuevo Producto</h2>
            <p class="text-xs text-gray-500">Registrar producto en el catálogo</p>
          </div>
        </div>
        <button (click)="closeCreateModal()" class="p-2 rounded-lg hover:bg-gray-200 transition-colors">
          <i class="fas fa-times text-gray-500"></i>
        </button>
      </div>
    </div>

    <!-- Form -->
    <div class="px-6 py-5 space-y-4">
      <!-- Código + EAN -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Código <span class="text-red-500">*</span></label>
          <input type="text" [(ngModel)]="newProduct.code" placeholder="Ej: LGG19UG01B40UN"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">EAN / UPC</label>
          <input type="text" [(ngModel)]="newProduct.ean_upc" placeholder="Ej: 8806096459799"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        </div>
      </div>

      <!-- Nombre -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Nombre del producto <span class="text-red-500">*</span></label>
        <input type="text" [(ngModel)]="newProduct.name" placeholder="Ej: LG AIRE ACOND SPLIT 12000BTU"
               class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      </div>

      <!-- Marca + Categoría -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Marca</label>
          <input type="text" [(ngModel)]="newProduct.brand" placeholder="Ej: LG, Samsung"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Categoría</label>
          <input type="text" [(ngModel)]="newProduct.category" placeholder="Ej: Electrodomésticos"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        </div>
      </div>

      <!-- Material + N° Material -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Material</label>
          <input type="text" [(ngModel)]="newProduct.material" placeholder="Código de material"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">N° Material</label>
          <input type="text" [(ngModel)]="newProduct.numero_material" placeholder="Descripción SAP"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        </div>
      </div>

      <!-- Sector -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Sector</label>
        <input type="number" [(ngModel)]="newProduct.se" placeholder="Ej: 19"
               class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      </div>
    </div>

    <!-- Actions -->
    <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 flex items-center justify-end gap-3">
      <button (click)="closeCreateModal()"
              class="px-4 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors">
        Cancelar
      </button>
      <button (click)="saveNewProduct()"
              [disabled]="savingProduct || !newProduct.code?.trim() || !newProduct.name?.trim()"
              class="px-5 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
        <i *ngIf="savingProduct" class="fas fa-spinner fa-spin"></i>
        <i *ngIf="!savingProduct" class="fas fa-check"></i>
        {{savingProduct ? 'Guardando...' : 'Crear Producto'}}
      </button>
    </div>
  </div>
</div>

<!-- ===================== MODAL: EDITAR PRODUCTO ===================== -->
<div *ngIf="editingProduct" class="fixed inset-0 z-50 flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" (click)="cancelEdit()"></div>

  <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center">
            <i class="fas fa-pen text-yellow-600"></i>
          </div>
          <div>
            <h2 class="text-lg font-bold text-gray-900">Editar Producto</h2>
            <p class="text-xs text-gray-500 font-mono">{{editingProduct.code}}</p>
          </div>
        </div>
        <button (click)="cancelEdit()" class="p-2 rounded-lg hover:bg-gray-200 transition-colors">
          <i class="fas fa-times text-gray-500"></i>
        </button>
      </div>
    </div>

    <div class="px-6 py-5 space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
        <input type="text" [(ngModel)]="editForm.name"
               class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Marca</label>
          <input type="text" [(ngModel)]="editForm.brand"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Categoría</label>
          <input type="text" [(ngModel)]="editForm.category"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Material</label>
          <input type="text" [(ngModel)]="editForm.material"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">N° Material</label>
          <input type="text" [(ngModel)]="editForm.numero_material"
                 class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Sector</label>
        <input type="number" [(ngModel)]="editForm.se" placeholder="Ej: 19"
               class="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>
    </div>

    <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 flex items-center justify-end gap-3">
      <button (click)="cancelEdit()"
              class="px-4 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors">
        Cancelar
      </button>
      <button (click)="saveEdit()"
              [disabled]="savingEdit"
              class="px-5 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-50 flex items-center gap-2">
        <i *ngIf="savingEdit" class="fas fa-spinner fa-spin"></i>
        <i *ngIf="!savingEdit" class="fas fa-check"></i>
        {{savingEdit ? 'Guardando...' : 'Guardar Cambios'}}
      </button>
    </div>
  </div>
</div>
